/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgNeo4JIconWhiteBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 86 79"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M57.3779 0C40.5967 0 29.3328 9.8948 29.3328 28.9973V42.5747C30.9412 41.7692 32.7812 41.3085 34.7344 41.3085C36.6877 41.3085 38.5277 41.7692 40.2519 42.5747V28.8815C40.2519 16.4545 47.0328 10.1264 57.3779 10.1264C67.7231 10.1264 74.504 16.4545 74.504 28.8815V58.6843H85.423V28.8815C85.5388 9.6658 74.1592 0 57.3779 0Z"
      fill="white"
    />
    <path
      d="M4.73608 32.7957C3.35676 33.4854 2.09321 34.6358 1.17192 36.1335C0.253212 37.6287 -0.0916182 39.2395 0.0216118 40.8505C0.137412 43.7276 1.7458 46.373 4.38868 47.8682C6.80258 49.2475 9.56128 48.9028 12.2042 48.3288C15.4235 47.5233 18.1822 47.1785 21.0542 48.9053H21.17C26.1135 51.7824 26.1135 59.0317 21.17 61.9062H21.0542C18.1797 63.6327 15.421 63.2877 12.2042 62.4827C9.67448 61.793 6.91578 61.4481 4.38868 62.9436C1.7458 64.4386 0.250642 67.1996 0.0216118 69.9606C-0.0941982 71.5716 0.250642 73.1827 1.17192 74.6777C2.09063 76.1736 3.24095 77.3236 4.73608 78.0156C7.26578 79.2816 10.3693 79.2817 13.0122 77.7867C15.4261 76.4076 16.5764 73.7596 17.2661 71.2266C18.1848 68.0056 19.2193 65.4726 22.2096 63.8616C25.0841 62.1352 27.8428 62.4827 31.0596 63.2877C33.5893 63.9776 36.348 64.3227 38.8751 62.8277C41.518 61.3324 43.0131 58.571 43.2422 55.8097V54.6594C43.1264 51.7823 41.518 49.1369 38.8751 47.6417C36.4612 46.2598 33.7025 46.6073 31.0596 47.1812C27.8403 47.9867 25.0816 48.3315 22.2096 46.6047C19.3351 44.878 18.1874 42.4614 17.2661 39.2395C16.5764 36.7073 15.4261 34.1776 13.0122 32.6799C10.3693 31.5296 7.26578 31.5296 4.73608 32.7957Z"
      fill="white"
    />
  </svg>
);
const SvgNeo4JIconWhite = wrapIcon(SvgNeo4JIconWhiteBase);
export default SvgNeo4JIconWhite;
